import TypeA from './TypeA/TypeA';

const SkinnySelfcareA = TypeA;

export default SkinnySelfcareA;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/SkinnyBanner/Selfcare/index.js